export interface LocationConfig {
    id: string;
    locationName: string;
    city: string;
    country: string;
    currencySymbol: string;
    currencyCode: string;
    countryCode: string;
    appRegion: string;
    organizationId: string;
    organizationName: string;
    stripeLiveKey?: string;
    stripeTestKey?: string;
    // Additional fields for store configuration
    availableTimezones: string[];
    availableCurrencies: string[];
    availableCountries: string[];
  }
  
  export const LOCATION_OPTIONS: LocationConfig[] = [
    {
      id: "uk-london-final-mile",
      locationName: "Final Mile, London Timezone",
      city: "London",
      country: "United Kingdom",
      currencySymbol: "£",
      currencyCode: "GBP",
      countryCode: "GB",
      appRegion: "europe-west2",
      organizationId: "dineukfinalmile-7210b4",
      organizationName: "DINEUKFINALMILE",
      stripeLiveKey: "pk_live_51Q7pTbG0ADuORob5LInoxXYYyTMQyMS9bWmkAAnuWmjXn8tB1qsflYtVe3nMERbfQRAg6WeI3tsoyEQAGQulsOYk00cM3OkQ9I",
      stripeTestKey: "pk_test_51Q7pTbG0ADuORob55on97tLfUXb53iBuNIkxB0Ae4JDvcXTrvXMyS8hHDwSsG826eLm7VIFHxCS7CWYAt2zPKuWZ00rHTRPygf",
      availableTimezones: [
        'Europe/London',
        'Europe/Dublin',
        'Europe/Edinburgh'
      ],
      availableCurrencies: ['GBP', 'EUR'],
      availableCountries: ['United Kingdom', 'Ireland']
    },
    {
      id: "us-newyork",
      locationName: "Dine 99, New York Timezone",
      city: "New York",
      country: "United States",
      currencySymbol: "$",
      currencyCode: "USD",
      countryCode: "US",
      appRegion: "us-east1",
      organizationId: "dineusa99-268641",
      organizationName: "DINEUSA99",
      stripeLiveKey: "pk_live_51RVbvAJ4GIfckOj0PvhyH9h6z4T4XjhDywcKKmvW86hmKzEJQDq45Rw4TIIfw7CMv922CoxFgbn3LZDU90SsV4qW00U51Q8Cr1",
      stripeTestKey: "pk_test_51RVbvAJ4GIfckOj0vyfsKmnLtmgFLqFx5dRCLbhYd1E61W7Ny49p1ULd0wCReUcvEdg7Q5Y77PMkfDyczXrRpQLd00kq93PlzT",
      availableTimezones: [
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Los_Angeles',
        'America/Phoenix',
        'America/Anchorage',
        'Pacific/Honolulu'
      ],
      availableCurrencies: ['USD'],
      availableCountries: ['United States']
    }
  ];
  
  // Helper functions
  export const getLocationById = (locationId: string): LocationConfig => {
    return LOCATION_OPTIONS.find(loc => loc.id === locationId) || LOCATION_OPTIONS[0];
  };
  
  export const getLocationByRegion = (region: string): LocationConfig => {
    return LOCATION_OPTIONS.find(loc => loc.appRegion === region) || LOCATION_OPTIONS[0];
  };
  
  export const getLocationByOrganization = (organizationName: string): LocationConfig => {
    return LOCATION_OPTIONS.find(loc => loc.organizationName === organizationName) || LOCATION_OPTIONS[0];
  };